import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

export default function ResourcesPage() {
    const [resources, setResources] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchResources();
    }, []);

    const fetchResources = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}admin/uploads`);
            const allResources = response.data.uploads.map((upload) => ({
                ...upload,
                resource_url: upload.resource_type === 1 ? upload.url : `${process.env.REACT_APP_R2_DEVURL}/public/${upload.file_path}`,
            }));
            setResources(allResources);
        } catch (error) {
            console.error("Error fetching resources:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="px-1 sm:px-4 my-2 xl:my-0 xl:p-4 h-screen w-full">
            <div className="flex justify-between mb-8 items-center">
                <h1 className="text-lg font-bold">Resources</h1>
            </div>

            {loading ? (
                <div className="text-center">Loading...</div>
            ) : (
                <div className="flex flex-wrap gap-4">
                    {resources.map((resource) => (
                        <a key={resource.id} href={resource.resource_url} target="_blank" className="bg-primary text-white px-4 py-2 rounded-full">
                            {resource.display_name}
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
}
